(function ($) {
  Drupal.behaviors.r4_video_tvc_mob = {
    attach: function (context, settings) {
      $('#r4_mod2', context).once('r4_video_tvc_mob', function () {
        /* PARALLAX BACKGROUND */
        // Init the controller.
        var controller = new ScrollMagic.Controller();
        // Set the parallax duration
        var windowHeight = $(window).height();

        parallaxDuration = windowHeight / 1.4;

        // Set the scene/
        var r4_mod2_scene1 = new ScrollMagic.Scene({
          triggerElement: '#r4_mod2',
          duration: parallaxDuration
        })
          .setTween('.r4_video_tvc_parallax', 8, {
            top: '-60%',
            ease: Linear.easeNone
          })
          .addTo(controller);
      });
    }
  };
})(jQuery);
